// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundHint } from "@microsoft/fast-components-styles-msft";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { fontFamily, getEmojiMask, getEmojiStylesByWidth } from "@msnews/social-utils";

const emojiSize = 16;

export const MostReactionsStyles = (config: DesignSystem) => ({
    mostReactionsContainer: {
        "font-family": fontFamily,
        display: "flex",
        "align-items": "center",
        "min-height": "20px",
        background: "none",
        padding: "0",
        overflow: "visible",
        position: "relative",
        height: "auto",
        border: "none",
        cursor: "pointer",

        "& div.emoji-icon": {
            ...getEmojiStylesByWidth(16),
            transition: "none"
        },

        "&:hover:enabled": {
            background: "none"
        },

        "& .cwt-icon": {
            padding: "0 4px",
            "font-size": `${emojiSize}px !important`,
            "align-items": "flex-start",

            "& .cwt-icon-label": {
                padding: "0",
                margin: "1px 0 0",
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "3px",
                "font-size": "13px",
                "line-height": "1"
            },

            "& .emoji-icon": {
                "&:last-child": {
                },

                "&:nth-child(1)": {
                    "z-index": 2
                },
                "&:nth-child(2)": {
                    "z-index": 1
                },
                "&:nth-child(3)": {
                    "z-index": 0
                }
            }
        }
    },
    seperatorV: {
        "font-size": "11px",
        "font-weight": "100",
        color: neutralForegroundHint,
        margin: applyLocalizedProperty("-5px 12px 0 -2px", "-5px -2px 0 12px", config.direction),
        opacity: ".55"
    },
    likeMask: {
        "-webkit-mask-image": `${getEmojiMask([applyLocalizedProperty("likeMaskImage", "likeMaskImageRTL", config.direction)].join(), emojiSize)}`,
        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-3px"
    },
    loveMask: {
        "-webkit-mask-image": `${getEmojiMask([applyLocalizedProperty("loveMaskImage", "loveMaskImageRTL", config.direction)].join(), emojiSize)}`,
        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-3px"
    },
    circleMask: {
        "-webkit-mask-image": `${getEmojiMask([applyLocalizedProperty("circleMaskImage", "circleMaskImageRTL", config.direction)].join(), emojiSize)}`,
        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-3px"
    }
});